function generateRandom12DigitNumber() {
  let randomDecimal = Math.random();
  let random12DigitNumber = Math.floor(
    randomDecimal * (Math.pow(10, 12) - Math.pow(10, 11)) + Math.pow(10, 11)
  );

  return random12DigitNumber;
}
export default generateRandom12DigitNumber;
